module.exports = __webpack_public_path__ + "img/Asset3.9ece5d86.png";